import { useSiteContent } from "@/shared/content/SiteContentProvider"
import { handleAnchorClick, isExternalHref } from "@/shared/lib/navigation"
import { Logo } from "@/shared/layout/Logo"
import { CookieBanner } from "@/shared/layout/CookieBanner"

export function Footer() {
  const { footerColumns, company } = useSiteContent()

  return (
    <>
      <footer className="bg-verde-profundo text-off-white">
        <div className="max-w-[1280px] mx-auto px-6 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
            <div className="flex flex-col gap-6">
              <Logo tone="light" className="h-14 w-auto" />

              <div className="flex flex-col gap-1.5 text-sm text-off-white/60 leading-relaxed">
                <p>{company.legalName}</p>
                <p>{company.taxId}</p>
                <p>{company.address}</p>
              </div>

              <div className="flex flex-col gap-1 text-sm text-off-white/60">
                <a
                  href={company.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-dourado-claro transition-colors"
                >
                  {company.instagramHandle}
                </a>
                <a
                  href={`mailto:${company.email}`}
                  className="hover:text-dourado-claro transition-colors break-all"
                >
                  {company.email}
                </a>
              </div>
            </div>

            {footerColumns.map((column) => (
              <div key={column.title} className="flex flex-col gap-4">
                <h3 className="text-xs font-semibold tracking-widest uppercase text-dourado-claro">
                  {column.title}
                </h3>

                <ul className="flex flex-col gap-2.5">
                  {column.links.map((link) => {
                    const external = isExternalHref(link.href)

                    return (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          onClick={(event) => handleAnchorClick(event, link.href)}
                          target={external ? "_blank" : undefined}
                          rel={external ? "noopener noreferrer" : undefined}
                          className="text-sm text-off-white/65 hover:text-off-white transition-colors"
                        >
                          {link.label}
                        </a>
                      </li>
                    )
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-off-white/8">
          <div className="max-w-[1280px] mx-auto px-6 py-6">
            <p className="text-xs text-off-white/40 leading-relaxed max-w-3xl">
              Coberturas, carências, coparticipações, limites, exclusões e demais condições estão sujeitas ao
              contrato de adesão e ao regulamento do plano. Consulte as condições completas antes da contratação.
            </p>
            <p className="text-xs text-off-white/25 mt-3">
              © {new Date().getFullYear()} DIMPET Saúde Preventiva. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>

      <CookieBanner />
    </>
  )
}
